import React, { ReactNode } from 'react';
import { AnalyticsServiceProvider } from './AnalyticsServiceProvider';
import { useAppSettings } from '../../state/providers/AppSettingsProvider';

interface AnalyticsServiceProviderWrapperProps {
  children: ReactNode;
}

export const AnalyticsServiceProviderWrapper: React.FC<AnalyticsServiceProviderWrapperProps> = ({ children }) => {
  const { settings, loading } = useAppSettings();
  
  // Always provide the context, but pass settings only when loaded
  // This ensures we use the CMS-configured measurement ID
  return (
    <AnalyticsServiceProvider appSettings={loading ? null : settings}>
      {children}
    </AnalyticsServiceProvider>
  );
};
